export default __webpack_public_path__ + "static/media/dragon_12.e6e4836b.mp3";